function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/tableutils
 */
import { CKEditorError } from 'ckeditor5/src/utils';
import { Plugin } from 'ckeditor5/src/core';
import TableWalker from './tablewalker';
import { createEmptyTableCell, updateNumericAttribute } from './utils/common';
import { removeEmptyColumns, removeEmptyRows } from './utils/structure';
/**
 * The table utilities plugin.
 *
 * @extends module:core/plugin~Plugin
 */

var TableUtils = /*#__PURE__*/function (_Plugin) {
  _inherits(TableUtils, _Plugin);

  var _super = _createSuper(TableUtils);

  function TableUtils() {
    _classCallCheck(this, TableUtils);

    return _super.apply(this, arguments);
  }

  _createClass(TableUtils, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      this.decorate('insertColumns');
      this.decorate('insertRows');
    }
    /**
     * Returns the table cell location as an object with table row and table column indexes.
     *
     * For instance, in the table below:
     *
     *		    0   1   2   3
     *		  +---+---+---+---+
     *		0 | a     | b | c |
     *		  +       +   +---+
     *		1 |       |   | d |
     *		  +---+---+   +---+
     *		2 | e     |   | f |
     *		  +---+---+---+---+
     *
     * the method will return:
     *
     *		const cellA = table.getNodeByPath( [ 0, 0 ] );
     *		editor.plugins.get( 'TableUtils' ).getCellLocation( cellA );
     *		// will return { row: 0, column: 0 }
     *
     *		const cellD = table.getNodeByPath( [ 1, 0 ] );
     *		editor.plugins.get( 'TableUtils' ).getCellLocation( cellD );
     *		// will return { row: 1, column: 3 }
     *
     * @param {module:engine/model/element~Element} tableCell
     * @returns {Object} Returns a `{row, column}` object.
     */

  }, {
    key: "getCellLocation",
    value: function getCellLocation(tableCell) {
      var tableRow = tableCell.parent;
      var table = tableRow.parent;
      var rowIndex = table.getChildIndex(tableRow);
      var tableWalker = new TableWalker(table, {
        row: rowIndex
      });

      var _iterator = _createForOfIteratorHelper(tableWalker),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _ref2 = _step.value;
          var cell = _ref2.cell;
          var row = _ref2.row;
          var column = _ref2.column;

          if (cell === tableCell) {
            return {
              row: row,
              column: column
            };
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    /**
     * Creates an empty table with a proper structure. The table needs to be inserted into the model,
     * for example, by using the {@link module:engine/model/model~Model#insertContent} function.
     *
     *		model.change( ( writer ) => {
     *			// Create a table of 2 rows and 7 columns:
     *			const table = tableUtils.createTable( writer, { rows: 2, columns: 7 } );
     *
     *			// Insert a table to the model at the best position taking the current selection:
     *			model.insertContent( table );
     *		}
     *
     * @param {module:engine/model/writer~Writer} writer The model writer.
     * @param {Object} options
     * @param {Number} [options.rows=2] The number of rows to create.
     * @param {Number} [options.columns=2] The number of columns to create.
     * @param {Number} [options.headingRows=0] The number of heading rows.
     * @param {Number} [options.headingColumns=0] The number of heading columns.
     * @returns {module:engine/model/element~Element} The created table element.
     */

  }, {
    key: "createTable",
    value: function createTable(writer, options) {
      var table = writer.createElement('table');
      var rows = parseInt(options.rows) || 2;
      var columns = parseInt(options.columns) || 2;
      createEmptyRows(writer, table, 0, rows, columns);

      if (options.headingRows) {
        updateNumericAttribute('headingRows', options.headingRows, table, writer, 0);
      }

      if (options.headingColumns) {
        updateNumericAttribute('headingColumns', options.headingColumns, table, writer, 0);
      }

      return table;
    }
    /**
     * Inserts rows into a table.
     *
     *		editor.plugins.get( 'TableUtils' ).insertRows( table, { at: 1, rows: 2 } );
     *
     * Assuming the table on the left, the above code will transform it to the table on the right:
     *
     *		row index
     *		  0 +---+---+---+       `at` = 1,      +---+---+---+ 0
     *		    | a | b | c |       `rows` = 2,    | a | b | c |
     *		  1 +   +---+---+   <-- insert here    +   +---+---+ 1
     *		    |   | d | e |                      |   |   |   |
     *		  2 +   +---+---+       will give:     +   +---+---+ 2
     *		    |   | f | g |                      |   |   |   |
     *		  3 +---+---+---+                      +   +---+---+ 3
     *		                                       |   | d | e |
     *		                                       +   +---+---+ 4
     *		                                       +   + f | g |
     *		                                       +---+---+---+ 5
     *
     * @param {module:engine/model/element~Element} table The table model element where the rows will be inserted.
     * @param {Object} options
     * @param {Number} [options.at=0] The row index at which the rows will be inserted.
     * @param {Number} [options.rows=1] The number of rows to insert.
     * @param {Boolean|undefined} [options.copyStructureFromAbove] The flag for copying row structure. Note that
     * the row structure will not be copied if this option is not provided.
     */

  }, {
    key: "insertRows",
    value: function insertRows(table) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var model = this.editor.model;
      var insertAt = options.at || 0;
      var rowsToInsert = options.rows || 1;
      var isCopyStructure = options.copyStructureFromAbove !== undefined;
      var copyStructureFrom = options.copyStructureFromAbove ? insertAt - 1 : insertAt;
      var rows = this.getRows(table);
      var columns = this.getColumns(table);

      if (insertAt > rows) {
        /**
         * The `options.at` points at a row position that does not exist.
         *
         * @error tableutils-insertrows-insert-out-of-range
         */
        throw new CKEditorError('tableutils-insertrows-insert-out-of-range', this, {
          options: options
        });
      }

      model.change(function (writer) {
        var headingRows = table.getAttribute('headingRows') || 0; // Inserting rows inside heading section requires to update `headingRows` attribute as the heading section will grow.

        if (headingRows > insertAt) {
          updateNumericAttribute('headingRows', headingRows + rowsToInsert, table, writer, 0);
        } // Inserting at the end or at the beginning of a table doesn't require to calculate anything special.


        if (!isCopyStructure && (insertAt === 0 || insertAt === rows)) {
          createEmptyRows(writer, table, insertAt, rowsToInsert, columns);
          return;
        } // Iterate over all the rows above the inserted rows in order to check for the row-spanned cells.


        var walkerEndRow = isCopyStructure ? Math.max(insertAt, copyStructureFrom) : insertAt;
        var tableIterator = new TableWalker(table, {
          endRow: walkerEndRow
        }); // Store spans of the reference row to reproduce it's structure. This array is column number indexed.

        var rowColSpansMap = new Array(columns).fill(1);

        var _iterator2 = _createForOfIteratorHelper(tableIterator),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _ref4 = _step2.value;
            var row = _ref4.row;
            var column = _ref4.column;
            var cellHeight = _ref4.cellHeight;
            var cellWidth = _ref4.cellWidth;
            var cell = _ref4.cell;
            var lastCellRow = row + cellHeight - 1;
            var isOverlappingInsertedRow = row < insertAt && insertAt <= lastCellRow;
            var isReferenceRow = row <= copyStructureFrom && copyStructureFrom <= lastCellRow; // If the cell is row-spanned and overlaps the inserted row, then reserve space for it in the row map.

            if (isOverlappingInsertedRow) {
              // This cell overlaps the inserted rows so we need to expand it further.
              writer.setAttribute('rowspan', cellHeight + rowsToInsert, cell); // Mark this cell with negative number to indicate how many cells should be skipped when adding the new cells.

              rowColSpansMap[column] = -cellWidth;
            } // Store the colspan from reference row.
            else if (isCopyStructure && isReferenceRow) {
                rowColSpansMap[column] = cellWidth;
              }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        for (var rowIndex = 0; rowIndex < rowsToInsert; rowIndex++) {
          var tableRow = writer.createElement('tableRow');
          writer.insert(tableRow, table, insertAt);

          for (var cellIndex = 0; cellIndex < rowColSpansMap.length; cellIndex++) {
            var colspan = rowColSpansMap[cellIndex];
            var insertPosition = writer.createPositionAt(tableRow, 'end'); // Insert the empty cell only if this slot is not row-spanned from any other cell.

            if (colspan > 0) {
              createEmptyTableCell(writer, insertPosition, colspan > 1 ? {
                colspan: colspan
              } : null);
            } // Skip the col-spanned slots, there won't be any cells.


            cellIndex += Math.abs(colspan) - 1;
          }
        }
      });
    }
    /**
     * Inserts columns into a table.
     *
     *		editor.plugins.get( 'TableUtils' ).insertColumns( table, { at: 1, columns: 2 } );
     *
     * Assuming the table on the left, the above code will transform it to the table on the right:
     *
     *		0   1   2   3                   0   1   2   3   4   5
     *		+---+---+---+                   +---+---+---+---+---+
     *		| a     | b |                   | a             | b |
     *		+       +---+                   +               +---+
     *		|       | c |                   |               | c |
     *		+---+---+---+     will give:    +---+---+---+---+---+
     *		| d | e | f |                   | d |   |   | e | f |
     *		+---+   +---+                   +---+---+---+   +---+
     *		| g |   | h |                   | g |   |   |   | h |
     *		+---+---+---+                   +---+---+---+---+---+
     *		| i         |                   | i                 |
     *		+---+---+---+                   +---+---+---+---+---+
     *		    ^---- insert here, `at` = 1, `columns` = 2
     *
     * @param {module:engine/model/element~Element} table The table model element where the columns will be inserted.
     * @param {Object} options
     * @param {Number} [options.at=0] The column index at which the columns will be inserted.
     * @param {Number} [options.columns=1] The number of columns to insert.
     */

  }, {
    key: "insertColumns",
    value: function insertColumns(table) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var model = this.editor.model;
      var insertAt = options.at || 0;
      var columnsToInsert = options.columns || 1;
      model.change(function (writer) {
        var headingColumns = table.getAttribute('headingColumns'); // Inserting columns inside heading section requires to update `headingColumns` attribute as the heading section will grow.

        if (insertAt < headingColumns) {
          writer.setAttribute('headingColumns', headingColumns + columnsToInsert, table);
        }

        var tableColumns = _this.getColumns(table); // Inserting at the end and at the beginning of a table doesn't require to calculate anything special.


        if (insertAt === 0 || tableColumns === insertAt) {
          var _iterator3 = _createForOfIteratorHelper(table.getChildren()),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var tableRow = _step3.value;

              // Ignore non-row elements inside the table (e.g. caption).
              if (!tableRow.is('element', 'tableRow')) {
                continue;
              }

              createCells(columnsToInsert, writer, writer.createPositionAt(tableRow, insertAt ? 'end' : 0));
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          return;
        }

        var tableWalker = new TableWalker(table, {
          column: insertAt,
          includeAllSlots: true
        });

        var _iterator4 = _createForOfIteratorHelper(tableWalker),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var tableSlot = _step4.value;
            var row = tableSlot.row,
                cell = tableSlot.cell,
                cellAnchorColumn = tableSlot.cellAnchorColumn,
                cellAnchorRow = tableSlot.cellAnchorRow,
                cellWidth = tableSlot.cellWidth,
                cellHeight = tableSlot.cellHeight; // When iterating over column the table walker outputs either:
            // - cells at given column index (cell "e" from method docs),
            // - spanned columns (spanned cell from row between cells "g" and "h" - spanned by "e", only if `includeAllSlots: true`),
            // - or a cell from the same row which spans over this column (cell "a").

            if (cellAnchorColumn < insertAt) {
              // If cell is anchored in previous column, it is a cell that spans over an inserted column (cell "a" & "i").
              // For such cells expand them by a number of columns inserted.
              writer.setAttribute('colspan', cellWidth + columnsToInsert, cell); // This cell will overlap cells in rows below so skip them (because of `includeAllSlots` option) - (cell "a")

              var lastCellRow = cellAnchorRow + cellHeight - 1;

              for (var i = row; i <= lastCellRow; i++) {
                tableWalker.skipRow(i);
              }
            } else {
              // It's either cell at this column index or spanned cell by a row-spanned cell from row above.
              // In table above it's cell "e" and a spanned position from row below (empty cell between cells "g" and "h")
              createCells(columnsToInsert, writer, tableSlot.getPositionBefore());
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      });
    }
    /**
     * Removes rows from the given `table`.
     *
     * This method re-calculates the table geometry including `rowspan` attribute of table cells overlapping removed rows
     * and table headings values.
     *
     *		editor.plugins.get( 'TableUtils' ).removeRows( table, { at: 1, rows: 2 } );
     *
     * Executing the above code in the context of the table on the left will transform its structure as presented on the right:
     *
     *		row index
     *		    ┌───┬───┬───┐        `at` = 1        ┌───┬───┬───┐
     *		  0 │ a │ b │ c │        `rows` = 2      │ a │ b │ c │ 0
     *		    │   ├───┼───┤                        │   ├───┼───┤
     *		  1 │   │ d │ e │  <-- remove from here  │   │ d │ g │ 1
     *		    │   │   ├───┤        will give:      ├───┼───┼───┤
     *		  2 │   │   │ f │                        │ h │ i │ j │ 2
     *		    │   │   ├───┤                        └───┴───┴───┘
     *		  3 │   │   │ g │
     *		    ├───┼───┼───┤
     *		  4 │ h │ i │ j │
     *		    └───┴───┴───┘
     *
     * @param {module:engine/model/element~Element} table
     * @param {Object} options
     * @param {Number} options.at The row index at which the removing rows will start.
     * @param {Number} [options.rows=1] The number of rows to remove.
     */

  }, {
    key: "removeRows",
    value: function removeRows(table, options) {
      var _this2 = this;

      var model = this.editor.model;
      var rowsToRemove = options.rows || 1;
      var rowCount = this.getRows(table);
      var first = options.at;
      var last = first + rowsToRemove - 1;

      if (last > rowCount - 1) {
        /**
         * The `options.at` param must point at existing row and `options.rows` must not exceed the rows in the table.
         *
         * @error tableutils-removerows-row-index-out-of-range
         */
        throw new CKEditorError('tableutils-removerows-row-index-out-of-range', this, {
          table: table,
          options: options
        });
      }

      model.change(function (writer) {
        // Removing rows from the table require that most calculations to be done prior to changing table structure.
        // Preparations must be done in the same enqueueChange callback to use the current table structure.
        // 1. Preparation - get row-spanned cells that have to be modified after removing rows.
        var _getCellsToMoveAndTri = getCellsToMoveAndTrimOnRemoveRow(table, first, last),
            cellsToMove = _getCellsToMoveAndTri.cellsToMove,
            cellsToTrim = _getCellsToMoveAndTri.cellsToTrim; // 2. Execution
        // 2a. Move cells from removed rows that extends over a removed section - must be done before removing rows.
        // This will fill any gaps in a rows below that previously were empty because of row-spanned cells.


        if (cellsToMove.size) {
          var rowAfterRemovedSection = last + 1;
          moveCellsToRow(table, rowAfterRemovedSection, cellsToMove, writer);
        } // 2b. Remove all required rows.


        for (var i = last; i >= first; i--) {
          writer.remove(table.getChild(i));
        } // 2c. Update cells from rows above that overlap removed section. Similar to step 2 but does not involve moving cells.


        var _iterator5 = _createForOfIteratorHelper(cellsToTrim),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _ref6 = _step5.value;
            var rowspan = _ref6.rowspan;
            var cell = _ref6.cell;
            updateNumericAttribute('rowspan', rowspan, cell, writer);
          } // 2d. Adjust heading rows if removed rows were in a heading section.

        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }

        updateHeadingRows(table, first, last, writer); // 2e. Remove empty columns (without anchored cells) if there are any.

        if (!removeEmptyColumns(table, _this2)) {
          // If there wasn't any empty columns then we still need to check if this wasn't called
          // because of cleaning empty rows and we only removed one of them.
          removeEmptyRows(table, _this2);
        }
      });
    }
    /**
     * Removes columns from the given `table`.
     *
     * This method re-calculates the table geometry including the `colspan` attribute of table cells overlapping removed columns
     * and table headings values.
     *
     *		editor.plugins.get( 'TableUtils' ).removeColumns( table, { at: 1, columns: 2 } );
     *
     * Executing the above code in the context of the table on the left will transform its structure as presented on the right:
     *
     *		  0   1   2   3   4                       0   1   2
     *		┌───────────────┬───┐                   ┌───────┬───┐
     *		│ a             │ b │                   │ a     │ b │
     *		│               ├───┤                   │       ├───┤
     *		│               │ c │                   │       │ c │
     *		├───┬───┬───┬───┼───┤     will give:    ├───┬───┼───┤
     *		│ d │ e │ f │ g │ h │                   │ d │ g │ h │
     *		├───┼───┼───┤   ├───┤                   ├───┤   ├───┤
     *		│ i │ j │ k │   │ l │                   │ i │   │ l │
     *		├───┴───┴───┴───┴───┤                   ├───┴───┴───┤
     *		│ m                 │                   │ m         │
     *		└───────────────────┘                   └───────────┘
     *		      ^---- remove from here, `at` = 1, `columns` = 2
     *
     * @param {module:engine/model/element~Element} table
     * @param {Object} options
     * @param {Number} options.at The row index at which the removing columns will start.
     * @param {Number} [options.columns=1] The number of columns to remove.
     */

  }, {
    key: "removeColumns",
    value: function removeColumns(table, options) {
      var _this3 = this;

      var model = this.editor.model;
      var first = options.at;
      var columnsToRemove = options.columns || 1;
      var last = options.at + columnsToRemove - 1;
      model.change(function (writer) {
        adjustHeadingColumns(table, {
          first: first,
          last: last
        }, writer);

        for (var removedColumnIndex = last; removedColumnIndex >= first; removedColumnIndex--) {
          for (var _i = 0, _arr = _toConsumableArray(new TableWalker(table)); _i < _arr.length; _i++) {
            var _ref8 = _arr[_i];
            var cell = _ref8.cell;
            var column = _ref8.column;
            var cellWidth = _ref8.cellWidth;

            // If colspaned cell overlaps removed column decrease its span.
            if (column <= removedColumnIndex && cellWidth > 1 && column + cellWidth > removedColumnIndex) {
              updateNumericAttribute('colspan', cellWidth - 1, cell, writer);
            } else if (column === removedColumnIndex) {
              // The cell in removed column has colspan of 1.
              writer.remove(cell);
            }
          }
        } // Remove empty rows that could appear after removing columns.


        if (!removeEmptyRows(table, _this3)) {
          // If there wasn't any empty rows then we still need to check if this wasn't called
          // because of cleaning empty columns and we only removed one of them.
          removeEmptyColumns(table, _this3);
        }
      });
    }
    /**
     * Divides a table cell vertically into several ones.
     *
     * The cell will be visually split into more cells by updating colspans of other cells in a column
     * and inserting cells (columns) after that cell.
     *
     * In the table below, if cell "a" is split into 3 cells:
     *
     *		+---+---+---+
     *		| a | b | c |
     *		+---+---+---+
     *		| d | e | f |
     *		+---+---+---+
     *
     * it will result in the table below:
     *
     *		+---+---+---+---+---+
     *		| a |   |   | b | c |
     *		+---+---+---+---+---+
     *		| d         | e | f |
     *		+---+---+---+---+---+
     *
     * So cell "d" will get its `colspan` updated to `3` and 2 cells will be added (2 columns will be created).
     *
     * Splitting a cell that already has a `colspan` attribute set will distribute the cell `colspan` evenly and the remainder
     * will be left to the original cell:
     *
     *		+---+---+---+
     *		| a         |
     *		+---+---+---+
     *		| b | c | d |
     *		+---+---+---+
     *
     * Splitting cell "a" with `colspan=3` into 2 cells will create 1 cell with a `colspan=a` and cell "a" that will have `colspan=2`:
     *
     *		+---+---+---+
     *		| a     |   |
     *		+---+---+---+
     *		| b | c | d |
     *		+---+---+---+
     *
     * @param {module:engine/model/element~Element} tableCell
     * @param {Number} numberOfCells
     */

  }, {
    key: "splitCellVertically",
    value: function splitCellVertically(tableCell) {
      var numberOfCells = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      var model = this.editor.model;
      var tableRow = tableCell.parent;
      var table = tableRow.parent;
      var rowspan = parseInt(tableCell.getAttribute('rowspan') || 1);
      var colspan = parseInt(tableCell.getAttribute('colspan') || 1);
      model.change(function (writer) {
        // First check - the cell spans over multiple rows so before doing anything else just split this cell.
        if (colspan > 1) {
          // Get spans of new (inserted) cells and span to update of split cell.
          var _breakSpanEvenly = breakSpanEvenly(colspan, numberOfCells),
              newCellsSpan = _breakSpanEvenly.newCellsSpan,
              updatedSpan = _breakSpanEvenly.updatedSpan;

          updateNumericAttribute('colspan', updatedSpan, tableCell, writer); // Each inserted cell will have the same attributes:

          var newCellsAttributes = {}; // Do not store default value in the model.

          if (newCellsSpan > 1) {
            newCellsAttributes.colspan = newCellsSpan;
          } // Copy rowspan of split cell.


          if (rowspan > 1) {
            newCellsAttributes.rowspan = rowspan;
          }

          var cellsToInsert = colspan > numberOfCells ? numberOfCells - 1 : colspan - 1;
          createCells(cellsToInsert, writer, writer.createPositionAfter(tableCell), newCellsAttributes);
        } // Second check - the cell has colspan of 1 or we need to create more cells then the currently one spans over.


        if (colspan < numberOfCells) {
          var _cellsToInsert = numberOfCells - colspan; // First step: expand cells on the same column as split cell.


          var tableMap = _toConsumableArray(new TableWalker(table)); // Get the column index of split cell.


          var _tableMap$find = tableMap.find(function (_ref9) {
            var cell = _ref9.cell;
            return cell === tableCell;
          }),
              splitCellColumn = _tableMap$find.column; // Find cells which needs to be expanded vertically - those on the same column or those that spans over split cell's column.


          var cellsToUpdate = tableMap.filter(function (_ref10) {
            var cell = _ref10.cell,
                cellWidth = _ref10.cellWidth,
                column = _ref10.column;
            var isOnSameColumn = cell !== tableCell && column === splitCellColumn;
            var spansOverColumn = column < splitCellColumn && column + cellWidth > splitCellColumn;
            return isOnSameColumn || spansOverColumn;
          }); // Expand cells vertically.

          var _iterator6 = _createForOfIteratorHelper(cellsToUpdate),
              _step6;

          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var _ref12 = _step6.value;
              var cell = _ref12.cell;
              var cellWidth = _ref12.cellWidth;
              writer.setAttribute('colspan', cellWidth + _cellsToInsert, cell);
            } // Second step: create columns after split cell.
            // Each inserted cell will have the same attributes:

          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }

          var _newCellsAttributes = {}; // Do not store default value in the model.
          // Copy rowspan of split cell.

          if (rowspan > 1) {
            _newCellsAttributes.rowspan = rowspan;
          }

          createCells(_cellsToInsert, writer, writer.createPositionAfter(tableCell), _newCellsAttributes);
          var headingColumns = table.getAttribute('headingColumns') || 0; // Update heading section if split cell is in heading section.

          if (headingColumns > splitCellColumn) {
            updateNumericAttribute('headingColumns', headingColumns + _cellsToInsert, table, writer);
          }
        }
      });
    }
    /**
     * Divides a table cell horizontally into several ones.
     *
     * The cell will be visually split into more cells by updating rowspans of other cells in the row and inserting rows with a single cell
     * below.
     *
     * If in the table below cell "b" is split into 3 cells:
     *
     *		+---+---+---+
     *		| a | b | c |
     *		+---+---+---+
     *		| d | e | f |
     *		+---+---+---+
     *
     * It will result in the table below:
     *
     *		+---+---+---+
     *		| a | b | c |
     *		+   +---+   +
     *		|   |   |   |
     *		+   +---+   +
     *		|   |   |   |
     *		+---+---+---+
     *		| d | e | f |
     *		+---+---+---+
     *
     * So cells "a" and "b" will get their `rowspan` updated to `3` and 2 rows with a single cell will be added.
     *
     * Splitting a cell that already has a `rowspan` attribute set will distribute the cell `rowspan` evenly and the remainder
     * will be left to the original cell:
     *
     *		+---+---+---+
     *		| a | b | c |
     *		+   +---+---+
     *		|   | d | e |
     *		+   +---+---+
     *		|   | f | g |
     *		+   +---+---+
     *		|   | h | i |
     *		+---+---+---+
     *
     * Splitting cell "a" with `rowspan=4` into 3 cells will create 2 cells with a `rowspan=1` and cell "a" will have `rowspan=2`:
     *
     *		+---+---+---+
     *		| a | b | c |
     *		+   +---+---+
     *		|   | d | e |
     *		+---+---+---+
     *		|   | f | g |
     *		+---+---+---+
     *		|   | h | i |
     *		+---+---+---+
     *
     * @param {module:engine/model/element~Element} tableCell
     * @param {Number} numberOfCells
     */

  }, {
    key: "splitCellHorizontally",
    value: function splitCellHorizontally(tableCell) {
      var numberOfCells = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      var model = this.editor.model;
      var tableRow = tableCell.parent;
      var table = tableRow.parent;
      var splitCellRow = table.getChildIndex(tableRow);
      var rowspan = parseInt(tableCell.getAttribute('rowspan') || 1);
      var colspan = parseInt(tableCell.getAttribute('colspan') || 1);
      model.change(function (writer) {
        // First check - the cell spans over multiple rows so before doing anything else just split this cell.
        if (rowspan > 1) {
          // Cache table map before updating table.
          var tableMap = _toConsumableArray(new TableWalker(table, {
            startRow: splitCellRow,
            endRow: splitCellRow + rowspan - 1,
            includeAllSlots: true
          })); // Get spans of new (inserted) cells and span to update of split cell.


          var _breakSpanEvenly2 = breakSpanEvenly(rowspan, numberOfCells),
              newCellsSpan = _breakSpanEvenly2.newCellsSpan,
              updatedSpan = _breakSpanEvenly2.updatedSpan;

          updateNumericAttribute('rowspan', updatedSpan, tableCell, writer);

          var _tableMap$find2 = tableMap.find(function (_ref13) {
            var cell = _ref13.cell;
            return cell === tableCell;
          }),
              cellColumn = _tableMap$find2.column; // Each inserted cell will have the same attributes:


          var newCellsAttributes = {}; // Do not store default value in the model.

          if (newCellsSpan > 1) {
            newCellsAttributes.rowspan = newCellsSpan;
          } // Copy colspan of split cell.


          if (colspan > 1) {
            newCellsAttributes.colspan = colspan;
          }

          var _iterator7 = _createForOfIteratorHelper(tableMap),
              _step7;

          try {
            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
              var tableSlot = _step7.value;
              var column = tableSlot.column,
                  row = tableSlot.row; // As both newly created cells and the split cell might have rowspan,
              // the insertion of new cells must go to appropriate rows:
              //
              // 1. It's a row after split cell + it's height.

              var isAfterSplitCell = row >= splitCellRow + updatedSpan; // 2. Is on the same column.

              var isOnSameColumn = column === cellColumn; // 3. And it's row index is after previous cell height.

              var isInEvenlySplitRow = (row + splitCellRow + updatedSpan) % newCellsSpan === 0;

              if (isAfterSplitCell && isOnSameColumn && isInEvenlySplitRow) {
                createCells(1, writer, tableSlot.getPositionBefore(), newCellsAttributes);
              }
            }
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }
        } // Second check - the cell has rowspan of 1 or we need to create more cells than the current cell spans over.


        if (rowspan < numberOfCells) {
          // We already split the cell in check one so here we split to the remaining number of cells only.
          var cellsToInsert = numberOfCells - rowspan; // This check is needed since we need to check if there are any cells from previous rows than spans over this cell's row.

          var _tableMap = _toConsumableArray(new TableWalker(table, {
            startRow: 0,
            endRow: splitCellRow
          })); // First step: expand cells.


          var _iterator8 = _createForOfIteratorHelper(_tableMap),
              _step8;

          try {
            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              var _ref15 = _step8.value;
              var cell = _ref15.cell;
              var cellHeight = _ref15.cellHeight;
              var _row = _ref15.row;

              // Expand rowspan of cells that are either:
              // - on the same row as current cell,
              // - or are below split cell row and overlaps that row.
              if (cell !== tableCell && _row + cellHeight > splitCellRow) {
                var rowspanToSet = cellHeight + cellsToInsert;
                writer.setAttribute('rowspan', rowspanToSet, cell);
              }
            } // Second step: create rows with single cell below split cell.

          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }

          var _newCellsAttributes2 = {}; // Copy colspan of split cell.

          if (colspan > 1) {
            _newCellsAttributes2.colspan = colspan;
          }

          createEmptyRows(writer, table, splitCellRow + 1, cellsToInsert, 1, _newCellsAttributes2); // Update heading section if split cell is in heading section.

          var headingRows = table.getAttribute('headingRows') || 0;

          if (headingRows > splitCellRow) {
            updateNumericAttribute('headingRows', headingRows + cellsToInsert, table, writer);
          }
        }
      });
    }
    /**
     * Returns the number of columns for a given table.
     *
     *		editor.plugins.get( 'TableUtils' ).getColumns( table );
     *
     * @param {module:engine/model/element~Element} table The table to analyze.
     * @returns {Number}
     */

  }, {
    key: "getColumns",
    value: function getColumns(table) {
      // Analyze first row only as all the rows should have the same width.
      // Using the first row without checking if it's a tableRow because we expect
      // that table will have only tableRow model elements at the beginning.
      var row = table.getChild(0);
      return _toConsumableArray(row.getChildren()).reduce(function (columns, row) {
        var columnWidth = parseInt(row.getAttribute('colspan') || 1);
        return columns + columnWidth;
      }, 0);
    }
    /**
     * Returns the number of rows for a given table. Any other element present in the table model is omitted.
     *
     *		editor.plugins.get( 'TableUtils' ).getRows( table );
     *
     * @param {module:engine/model/element~Element} table The table to analyze.
     * @returns {Number}
     */

  }, {
    key: "getRows",
    value: function getRows(table) {
      // Rowspan not included due to #6427.
      return Array.from(table.getChildren()).reduce(function (rowCount, child) {
        return child.is('element', 'tableRow') ? rowCount + 1 : rowCount;
      }, 0);
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'TableUtils';
    }
  }]);

  return TableUtils;
}(Plugin); // Creates empty rows at the given index in an existing table.
//
// @param {module:engine/model/writer~Writer} writer
// @param {module:engine/model/element~Element} table
// @param {Number} insertAt The row index of row insertion.
// @param {Number} rows The number of rows to create.
// @param {Number} tableCellToInsert The number of cells to insert in each row.


export { TableUtils as default };

function createEmptyRows(writer, table, insertAt, rows, tableCellToInsert) {
  var attributes = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

  for (var i = 0; i < rows; i++) {
    var tableRow = writer.createElement('tableRow');
    writer.insert(tableRow, table, insertAt);
    createCells(tableCellToInsert, writer, writer.createPositionAt(tableRow, 'end'), attributes);
  }
} // Creates cells at a given position.
//
// @param {Number} columns The number of columns to create
// @param {module:engine/model/writer~Writer} writer
// @param {module:engine/model/position~Position} insertPosition


function createCells(cells, writer, insertPosition) {
  var attributes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  for (var i = 0; i < cells; i++) {
    createEmptyTableCell(writer, insertPosition, attributes);
  }
} // Evenly distributes the span of a cell to a number of provided cells.
// The resulting spans will always be integer values.
//
// For instance breaking a span of 7 into 3 cells will return:
//
//		{ newCellsSpan: 2, updatedSpan: 3 }
//
// as two cells will have a span of 2 and the remainder will go the first cell so its span will change to 3.
//
// @param {Number} span The span value do break.
// @param {Number} numberOfCells The number of resulting spans.
// @returns {{newCellsSpan: Number, updatedSpan: Number}}


function breakSpanEvenly(span, numberOfCells) {
  if (span < numberOfCells) {
    return {
      newCellsSpan: 1,
      updatedSpan: 1
    };
  }

  var newCellsSpan = Math.floor(span / numberOfCells);
  var updatedSpan = span - newCellsSpan * numberOfCells + newCellsSpan;
  return {
    newCellsSpan: newCellsSpan,
    updatedSpan: updatedSpan
  };
} // Updates heading columns attribute if removing a row from head section.


function adjustHeadingColumns(table, removedColumnIndexes, writer) {
  var headingColumns = table.getAttribute('headingColumns') || 0;

  if (headingColumns && removedColumnIndexes.first < headingColumns) {
    var headingsRemoved = Math.min(headingColumns - 1
    /* Other numbers are 0-based */
    , removedColumnIndexes.last) - removedColumnIndexes.first + 1;
    writer.setAttribute('headingColumns', headingColumns - headingsRemoved, table);
  }
} // Calculates a new heading rows value for removing rows from heading section.


function updateHeadingRows(table, first, last, writer) {
  var headingRows = table.getAttribute('headingRows') || 0;

  if (first < headingRows) {
    var newRows = last < headingRows ? headingRows - (last - first + 1) : first;
    updateNumericAttribute('headingRows', newRows, table, writer, 0);
  }
} // Finds cells that will be:
// - trimmed - Cells that are "above" removed rows sections and overlap the removed section - their rowspan must be trimmed.
// - moved - Cells from removed rows section might stick out of. These cells are moved to the next row after a removed section.
//
// Sample table with overlapping & sticking out cells:
//
//      +----+----+----+----+----+
//      | 00 | 01 | 02 | 03 | 04 |
//      +----+    +    +    +    +
//      | 10 |    |    |    |    |
//      +----+----+    +    +    +
//      | 20 | 21 |    |    |    | <-- removed row
//      +    +    +----+    +    +
//      |    |    | 32 |    |    | <-- removed row
//      +----+    +    +----+    +
//      | 40 |    |    | 43 |    |
//      +----+----+----+----+----+
//
// In a table above:
// - cells to trim: '02', '03' & '04'.
// - cells to move: '21' & '32'.


function getCellsToMoveAndTrimOnRemoveRow(table, first, last) {
  var cellsToMove = new Map();
  var cellsToTrim = [];

  var _iterator9 = _createForOfIteratorHelper(new TableWalker(table, {
    endRow: last
  })),
      _step9;

  try {
    for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
      var _ref17 = _step9.value;
      var row = _ref17.row;
      var column = _ref17.column;
      var cellHeight = _ref17.cellHeight;
      var cell = _ref17.cell;
      var lastRowOfCell = row + cellHeight - 1;
      var isCellStickingOutFromRemovedRows = row >= first && row <= last && lastRowOfCell > last;

      if (isCellStickingOutFromRemovedRows) {
        var rowspanInRemovedSection = last - row + 1;
        var rowSpanToSet = cellHeight - rowspanInRemovedSection;
        cellsToMove.set(column, {
          cell: cell,
          rowspan: rowSpanToSet
        });
      }

      var isCellOverlappingRemovedRows = row < first && lastRowOfCell >= first;

      if (isCellOverlappingRemovedRows) {
        var rowspanAdjustment = void 0; // Cell fully covers removed section - trim it by removed rows count.

        if (lastRowOfCell >= last) {
          rowspanAdjustment = last - first + 1;
        } // Cell partially overlaps removed section - calculate cell's span that is in removed section.
        else {
            rowspanAdjustment = lastRowOfCell - first + 1;
          }

        cellsToTrim.push({
          cell: cell,
          rowspan: cellHeight - rowspanAdjustment
        });
      }
    }
  } catch (err) {
    _iterator9.e(err);
  } finally {
    _iterator9.f();
  }

  return {
    cellsToMove: cellsToMove,
    cellsToTrim: cellsToTrim
  };
}

function moveCellsToRow(table, targetRowIndex, cellsToMove, writer) {
  var tableWalker = new TableWalker(table, {
    includeAllSlots: true,
    row: targetRowIndex
  });

  var tableRowMap = _toConsumableArray(tableWalker);

  var row = table.getChild(targetRowIndex);
  var previousCell;

  var _iterator10 = _createForOfIteratorHelper(tableRowMap),
      _step10;

  try {
    for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
      var _ref19 = _step10.value;
      var column = _ref19.column;
      var cell = _ref19.cell;
      var isAnchor = _ref19.isAnchor;

      if (cellsToMove.has(column)) {
        var _cellsToMove$get = cellsToMove.get(column),
            cellToMove = _cellsToMove$get.cell,
            rowspan = _cellsToMove$get.rowspan;

        var targetPosition = previousCell ? writer.createPositionAfter(previousCell) : writer.createPositionAt(row, 0);
        writer.move(writer.createRangeOn(cellToMove), targetPosition);
        updateNumericAttribute('rowspan', rowspan, cellToMove, writer);
        previousCell = cellToMove;
      } else if (isAnchor) {
        // If cell is spanned then `cell` holds reference to overlapping cell. See ckeditor/ckeditor5#6502.
        previousCell = cell;
      }
    }
  } catch (err) {
    _iterator10.e(err);
  } finally {
    _iterator10.f();
  }
}